import { Process } from '@epihub/core/src/process/Process';

export function getHTTPProtocol() {
  return !isSecureEnvironment()
    ? 'http:'
    : 'https:';
}

export function isSecureEnvironment() {
  return Process.env.NODE_ENV !== 'local';
}
